
import React from 'react';
import './Footer.css';

const Footer = ({children}) => {
    return <footer className='Footer'>
        {children}
    </footer>
}

export default Footer;


// WEBPACK FOOTER //
// ./src/Footer.js